import { createApp } from "vue";
import App from "./ImageUpload.vue";
import { init as analytics } from "../../common/analytics";

import { initDevMode } from "@/dev/dev.init";

window.frisbuy = window.frisbuy || {};
window.frisbuy.widgets = window.frisbuy.widgets || {};

window.iuWidget = window.frisbuy.widgets.imageUpload = {
  ...window.frisbuy.widgets.imageUpload,
  open() {
    const { imageUpload } = window.frisbuy.widgets;
    const { popup, settings } = imageUpload;

    if (!popup) {
      const propsData = {
        propSettings: settings,
      };

      const iuWidgetInstance = createApp(App, propsData);

      imageUpload.popup = iuWidgetInstance;

      document.body.insertAdjacentHTML(
        "beforeEnd",
        '<div class="iu-widget"></div>'
      );

      const widgetElement = document.querySelector(".iu-widget");

      iuWidgetInstance.mount(widgetElement);
    }

    document.dispatchEvent(new CustomEvent("frisbuy:iu-open"));
  },
};

document.body.setAttribute("widget-iu-loaded", "true");

if (process.env.NODE_ENV === "development") {
  initDevMode();
}

if (window.iuWidget.settings) {
  analytics(window.iuWidget.settings);
}
